import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { registerModal } from '@gluedigital/modal'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import MarkdownMessage from '@gluedigital/markdown-message'
import { sendFormHubspot } from 'src/store/actions/form'

import './CtaModal.sass'

export const CtaModal = ({ sendForm }) => {
  // Form state
  const [state, setState] = useState('')
  const [email, setEmail] = useState('')
  const [terms, setTerms] = useState(false)

  // Some browsers don't implement :valid, so we do a naive validation here
  const isValid = email.length > 4 && terms

  const handleSubmit = (e) => {
    e.preventDefault()
    setState('sending')
    sendForm(email)
      .then(() => setState('sent'))
      .catch(e => {
        setState('error')
        console.warn(e)
      })
  }

  const formFinished =
    <div id="finished">
      <h1>
        <span className="check" />
        <MarkdownMessage id="cta-modal.finished.sended" />
      </h1>
      <h2><FormattedMessage id="cta-modal.finished.asap-contact" /></h2>
    </div>

  const formContact =
    <React.Fragment>
      <h1>
        <MarkdownMessage id="cta-modal.title" />
      </h1>
      <h2>
        <MarkdownMessage id="cta-modal.subtitle" />
      </h2>
      <h4>
        <FormattedMessage id="cta-modal.intro-text" />
      </h4>
      <label>
        <FormattedMessage id="cta-modal.email" >
          {(text) =>
            <input
              type="email"
              name="email"
              required autoFocus
              placeholder={text}
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          }
        </FormattedMessage>
      </label>
      <div className="consent">
        <label>
          <input
            type="checkbox"
            name="terms"
            required
            checked={terms}
            onChange={e => setTerms(e.target.checked)}
          />
          <span />
        </label>
        <div className="text">
          <Link target="_blank" to="https://glue.digital/legal"><MarkdownMessage id="cta-modal.legal.link" /></Link>
          <FormattedMessage id="cta-modal.contact.legal" />
        </div>
      </div>
      <button type="submit" disabled={!isValid}>
        <FormattedMessage id="cta-modal.send" />
      </button>
    </React.Fragment>

  return (
    <div id="cta-modal" className={state}>
      <div className="split">
        <div className="item left">
          <form onSubmit={handleSubmit}>
            <div className="logo" />
            { state === 'sent' ? formFinished : formContact }
          </form>
        </div>
        <div className="item right" />
      </div>
    </div>
  )
}

CtaModal.propTypes = {
  sendForm: PropTypes.func.isRequired
}

registerModal('cta-modal', connect(null, { sendForm: sendFormHubspot })(CtaModal))
